const config = {
  version: '2.2.5',
  width: window.innerWidth,
  height: window.innerHeight,
  staveWidth: 200,
  staveHeight: 40,
  staveMarginTop: 50,
  xIntervalBetweenNotes: 50,
  yIntervalBetweenNotes: 5,
  MN_centerNote: 6,
  framesPerBeat: 60,
  clefWidth: 65,
  alterationWidth: 15,
  tempoGapUnit: 20,
  tempoMaxBPM: 200,
  isSmallHeight: 420,
  maxNote: -20,
  minNote: 70,
};

export default config;
